import { connect } from 'react-redux';
import {loginByGoogle,logout} from '../actions/auth';
import {ROUTES,AUTH} from '../constants';
import {SearchIcon,PencilIcon,UserIcon,LogoutIcon} from '../components/atoms/Icons';
import { redirect } from 'redux-first-router';
import i18n from '../i18n';
import AppHeader from '../components/organisms/AppHeader/index';

const mapStateToProps = ({auth,profileReducer}) => {
	const appMenu = auth.authStatus === AUTH.LOGGED_IN ? [
		{action : (dispatch)=>{dispatch({type:ROUTES.CREATE_QUIZ_SELECTED});}, name : i18n.t('header.CreateQuiz'), Icon : PencilIcon},
		{action : (dispatch)=>{dispatch({type:ROUTES.SEARCH_QUIZ_SELECTED});}, name : i18n.t('header.FindQuiz'), Icon : SearchIcon},
	] : [];
	return {
		auth,
		appMenu,
		profile:profileReducer,
		profileMenu : [
			{
				action : (dispatch)=>{dispatch({type:ROUTES.PROFILE});}, 
				name : i18n.t('header.Profile'),
				Icon : UserIcon
			},
			{
				action : (dispatch)=>{
					dispatch(logout(()=>{
						dispatch(redirect({type:ROUTES.LANDING_PAGE}));
					},(error)=>{
						console.error(error);
					}));}, 
				name : i18n.t('header.Logout'),
				Icon : LogoutIcon
			}
		]
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onLogin: ()=>{
			dispatch(loginByGoogle());
		},
		onSelectMenu : (action)=>{
			action(dispatch);
		},
		onClickHome : ()=>{
			dispatch({
				type : ROUTES.HOME_PAGE
			});
		}
	};
};

export default connect(mapStateToProps,mapDispatchToProps)(AppHeader);